import React, { useState } from "react";
import classNames from "classnames";
import { SectionProps } from "../../utils/SectionProps";
import ButtonGroup from "../elements/ButtonGroup";
import Button from "../elements/Button";
import Image from "../elements/Image";
import Modal from "../elements/Modal";

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const CeedContactUsHero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = e => {
    e.preventDefault();
    setVideomodalactive(true);
  };

  const closeModal = e => {
    e.preventDefault();
    setVideomodalactive(false);
  };

  const outerClasses = classNames(
    "hero section center-content",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "hero-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  return (
    <section {...props} className={outerClasses}>
      <div className="container-sm">
        <div className="custom-section-inner">
          <div className="hero-content">
            <h1
              className="mt-0 mb-16 reveal-from-bottom"
              data-reveal-delay="200"
              style={{ textAlign: "center" }}
            >
              Contact Us
            </h1>
            <p style={{ textAlign: "left", textIndent: "50px" }}>
            Recently, Taos County was awarded over $2 Million from the Community Energy Efficiency Development (CEED) Block Grant from the State of New Mexico.  Our County, in partnership with community organizations, will help low-income households reduce their energy bills and energy use, reduce emissions, and create local jobs. 
            </p>
<h4><b>The service is free to qualifying households.</b></h4>
            <p style={{ textAlign: "left", textIndent: "50px" }}>
            In full day appointment, Certified Energy Auditors will visit your home, provide a written audit of its energy efficiency, install LED lighting, exterior door weatherstripping, water heater blankets, low flow faucets and showerheads, pipe wrap, gap filler and more.   Recommendations for follow-on energy efficiency improvements will also be made.
            If this is of interest to you, please fill out your contact details below.  When the program launches this Spring, we will contact you to qualify and schedule your appointment.  

              <br></br>
              <a href="tel:5755194039">575-519-4039 </a>
              or toll free at <a href="tel:8443377283">
                844-337-7283
              </a>(EDSSAVE)
            </p>
            <p style={{ textAlign: "left" }}>
              Your household is eligible for this program if you fulfill any of the following criteria:
            </p>
            <ul style={{ textAlign: "left" }}>
              <li>Direct income verification by the most recent tax returns of the household. To qualify for this program, your income must be under the 200% federal poverty level.   </li>
              <li>Eligibility is assumed if, within five years of household application:</li>
              <ul style={{ listStyleType: "circle" }}>
                <li>
                  Person(s) within the household receives federal or state disability assistance;
                </li>
                <li>
                	Person(s) within the household receives SNAP food benefits;                
                </li>
                <li>
                  Person(s) within the household receives Temporary Assistance for Needy Families (TANF) benefits;                
                </li>
                <li>
                	Person(s) within the household receives Medicaid or children’s health insurance program benefits;               
                </li>
                <li>
                	Person(s) within the household participates in a utility low-to-moderate income program, such as LIHEAP;                
                </li>
                <li>
                  Affordable housing verification evidenced by the fact that the resident receives low-income housing benefits or by mortgage or rental agreements;                
                </li>
            
              </ul>
            </ul>
            <p style={{ textAlign: "left" }}>
              Please reference the following table for eligibility for 200% poverty level:
            </p>
            <Image
                  title="U.S. Department of Energy"
                  src={require("./../../assets/images/2026-federal-poverty.png")}
                  alt="federal-poverty levels"
                  width={528}
                  height={396}
                />
            <div className="container-xs">
              <p
                className="m-0 mb-32 reveal-from-bottom"
                data-reveal-delay="400"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

CeedContactUsHero.propTypes = propTypes;
CeedContactUsHero.defaultProps = defaultProps;

export default CeedContactUsHero;
